import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  CardContent,
  Typography,
  Tooltip,
  IconButton,
  CircularProgress,
  Modal,
  InputLabel,
  Select,
  Grid,
  MenuItem,
  TextField,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Alert,
  AlertTitle,
  Backdrop
} from "@mui/material";
import { Theme, useTheme } from "@mui/material/styles";
import { createStyles, makeStyles } from "@mui/styles";
import { useLocalStorage } from "../../utils/LocalStorageHook";
import { GetEmailDL, GetMaterialList, getSalesOffices } from "../../utils/GetAdmin";
import { saveEmailDL } from "../../utils/PostAdmin";
import requestMissingContexts, { determineConfig, determineConfigLong, displayConfig } from "../../utils/GetContext";
import TableAbstraction from "../../componentUtils/TableAbstraction";
import { checkForRole } from "../../utils/GetAuth";
import LockIcon from "@mui/icons-material/Lock";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import SaveIcon from "@mui/icons-material/Save";
import Clear from "@mui/icons-material/Clear";
import { getSalesOfficesAndRoutes } from "../../utils/GetPlanning";
import { getRouteBuffer, saveRouteBuffer, editRouteBuffer, deleteRouteBuffer } from "../../utils/GetRouteBuffer";

// interface SalesOffice {
//   salesOffice: string;
//   name: string;
// }

interface DeliveryPlant {
  deliveryPlant: string;
  name: string;
}

function getModalStyle() {
  const top = 50;
  const left = 50;

  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`
  };
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    centerDiv: {
      textAlign: "center"
    },
    root: {},
    divWidth: {
      width: "100%"
    },
    modal: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    },
    modalGrid: {
      marginTop: theme.spacing(2)
    },
    modalTitle: {
      color: theme.palette.primary.main
    },
    modalCard: {},
    modalText: {
      width: 800
    },
    modalInput: {
      paddingLeft: "2px",
      paddingRight: "20px",
      width: "200px"
    },
    paper: {
      position: "absolute",
      backgroundColor: theme.palette.background.paper,
      border: `1px solid`,
      borderColor: theme.palette.border.main,
      boxShadow: theme.shadows[4],
      padding: theme.spacing(2, 2, 2)
    }
  }));
// interface rowData {
//   salesOffice: string;
//   dlName: string;
//   email: string;
// }

export default function AdminBufferConfig() {
  const classes = useStyles();
  const [rows, SetRows] = useState<any[]>([]);
  const [salesOrg] = useLocalStorage("SETTINGS.salesOrg", "");
  const [doneLoading, setDoneLoading] = React.useState<boolean>(true);
  const [clientId] = useLocalStorage("SETTINGS.clientId", 100);
  const enabled = checkForRole(`${clientId}`, salesOrg, "vs_admin");
  const [useCompact] = useLocalStorage("SETTINGS.compact", true);

  const [muiTable, setMuiTable] = React.useState<any>({ rpp: 25 });

  const [confirmDelete, setConfirmDelete] = React.useState<boolean>(false);

  const [modalStyle] = React.useState(getModalStyle);
  const [openEditWindow, setOpenEditWindow] = React.useState(false);
  const [state, setState] = React.useState<any>({
    // salesOffices: [],
    deliveryPlants:[],
    routes: [],
    materials: []
  });
  //console.log('🚀 ~ file: AdminBufferConfig.tsx ~ line 131 ~ AdminBufferConfig ~ state', state)
  const [routeOptions, setRouteOptions] = React.useState<any>([]);
  const initialSelectedOptions = {
    // salesOffices: null,
    deliveryPlant:null,
    route: null,
    material: 'All',
    onlineBuffer: null,
    offlineBuffer: null
  };
  const [selectedOptions, setSelectedOptions] = React.useState<any>(initialSelectedOptions);
  //console.log("selectedOptions--->",selectedOptions)
  const [inputError, setInputError] = React.useState<any>({
    onlineBuffer: false,
    offlineBuffer: false
  });
  const [edit, setEdit] = React.useState<boolean>(false);
  const [backdropLoader, setBackdropLoader] = React.useState<boolean>(false);

  const handleModalClose = () => {
    setOpenEditWindow(false);
    setEdit(false);
    setSelectedOptions(initialSelectedOptions);
    setRouteOptions([]);
    setState({...state, materials: []})
    setInputError({
      onlineBuffer: false,
      offlineBuffer: false
    })
  };
  const checkBufferExists = () => {
    if (rows?.length > 0) {
      const res: any = rows?.map((item: any) => {
        if (item.deliveryPlant === selectedOptions?.deliveryPlant && item.route === selectedOptions?.route && item.route === selectedOptions?.material) {
          return true;
        } else {
          return false;
        }
      });
      return res.includes(true);
    }
  };
  const handleModalSave = () => {
    const isBufferExist = checkBufferExists();
    if (isBufferExist && !edit) {
      alert("Selected Delivery Plant and Route already exist");
    } else {
      setBackdropLoader(true)
      if (edit) {
        editRouteBuffer(
          salesOrg,
          selectedOptions?.deliveryPlant,
          selectedOptions?.deliveryPlant,
          selectedOptions?.route,
          selectedOptions?.material,
          selectedOptions?.onlineBuffer,
          selectedOptions?.offlineBuffer
        )
          .then((ret) => {
            if (ret && ret.message === "success") {
              setEdit(false);
              setSelectedOptions(initialSelectedOptions);
              getRouteBuffer(salesOrg.toString()).then((v: any) => {
                setBackdropLoader(false)
                SetRows(v?.data);
              });
            }
          })
          .catch((err) => {
            setBackdropLoader(false)
            alert("Failed to save");
            //console.log("Error while saving", err);
          });
      } else {
        setBackdropLoader(true)
        saveRouteBuffer(
          salesOrg,
          selectedOptions?.deliveryPlant,
          selectedOptions?.deliveryPlant,
          selectedOptions?.route,
          selectedOptions?.material,
          selectedOptions?.onlineBuffer,
          selectedOptions?.offlineBuffer
        )
          .then((ret) => {
            if (ret && ret.message === "saved") {
              setSelectedOptions(initialSelectedOptions);
              getRouteBuffer(salesOrg.toString()).then((v: any) => {
                setBackdropLoader(false)
                SetRows(v?.data);
              });
            }
          })
          .catch((err) => {
            setBackdropLoader(false)
            alert("Failed to save");
           // console.log("Error while saving", err);
          });
      }
    }
    setOpenEditWindow(false);
  };
  const handleDelete = () => {
    setBackdropLoader(true)
    deleteRouteBuffer(salesOrg, selectedOptions?.deliveryPlant,selectedOptions?.deliveryPlant, selectedOptions?.route, selectedOptions?.material)
      .then((ret) => {
        if (ret && ret.message === "success") {
          setEdit(false);
          setSelectedOptions(initialSelectedOptions);
          getRouteBuffer(salesOrg.toString()).then((v: any) => {
            setBackdropLoader(false)
            SetRows(v?.data);
          });
        }
      })
      .catch((err) => {
        setBackdropLoader(false)
        alert("Failed to Delete");
        //console.log("Error while saving", err);
      });
  };
  const handleEdit = (tableMeta: any) => {
    setEdit(true);
    if (tableMeta) setCurrent(tableMeta);
    setOpenEditWindow(true);
  };
  const setCurrent = (tableMeta: any) => {
    const rts = state?.routes?.filter((elem: { deliveryPlant: any }) => elem.deliveryPlant === tableMeta.deliveryPlant);
    setRouteOptions(rts);
    setSelectedOptions({
      deliveryPlant: tableMeta.deliveryPlant,
      route: tableMeta.route,
      material: tableMeta.material,
      onlineBuffer: tableMeta.onlineBuffer,
      offlineBuffer: tableMeta.offlineBuffer
    });
  };
  const handleSOChange = (event: any) => {
   // console.log("event--->",event);
    const value = event.target.value;
    const rts = state?.routes?.filter((elem: { deliveringPlant: any }) => elem.deliveringPlant=== value);
    //console.log("rts--->",rts)
    setRouteOptions(rts);
    setSelectedOptions({ ...selectedOptions, deliveryPlant: value, material: 'All' });
  };

  const handleBufferOnChange = (value: any, type: any) => {
    if (type === "offline") {
      if (value < 0 || value > 99) {
        setInputError({ ...inputError, offlineBuffer: true });
      } else {
        setInputError({ ...inputError, offlineBuffer: false });
      }
      setSelectedOptions({ ...selectedOptions, offlineBuffer: value });
    } else {
      if (value < 0 || value > 99) {
        setInputError({ ...inputError, onlineBuffer: true });
      } else {
        setInputError({ ...inputError, onlineBuffer: false });
      }
      setSelectedOptions({ ...selectedOptions, onlineBuffer: value });
    }
  };

  const modalBody = (
    <div style={modalStyle} className={classes.paper}>
      <Typography variant="h4" className={classes.modalTitle} paragraph>
        Configure Buffer
      </Typography>
      <Grid container spacing={2} className={classes.modalGrid}>
        <Grid item xs={14} md={14} xl={12}>
          <Typography variant="subtitle1" className={classes.modalText} paragraph>
            Configure Buffer among the routes.
          </Typography>
          <Card className={classes.modalCard}>
            <CardContent>
              <Grid container rowSpacing={2} className={classes.modalGrid}>
                <Grid item xs={6} md={6} xl={4}>
                  <InputLabel>Delivery Plant</InputLabel>
                  <Select
                    label="Delivery Plant"
                    required
                    placeholder="Delivery Plant"
                    value={selectedOptions?.deliveryPlant}
                    inputProps={{ name: "Delivery Plant" }}
                    className={classes.modalInput}
                    onChange={handleSOChange}
                    disabled={edit}
                  >
                    <MenuItem key={"All"} value={"All"}>
                        All
                    </MenuItem>
                    {state?.deliveryPlants?.map((option: any) => (
                      <MenuItem key={option.deliveryPlant} value={option.deliveryPlant}>
                        {option.name}
                      </MenuItem>
                    ))}
                  </Select>
                </Grid>
                <Grid item xs={6} md={6} xl={4}>
                  <InputLabel>Route</InputLabel>
                  <Select
                    label="Route"
                    value={selectedOptions?.route}
                    className={classes.modalInput}
                    onChange={(e) => setSelectedOptions({ ...selectedOptions, route: e.target.value })}
                    required
                    disabled={edit}
                  >
                    <MenuItem key={"All"} value={"All"}>
                        All
                    </MenuItem>
                    {routeOptions?.map((option: any) => (
                      <MenuItem key={option.route} value={option.route}>
                        {option.route}
                      </MenuItem>
                    ))}
                  </Select>
                </Grid>
                <Grid item xs={6} md={6} xl={4}>
                  <InputLabel>Material</InputLabel>
                  <Select
                    label="Material"
                    value={selectedOptions?.material}
                    className={classes.modalInput}
                    onChange={(e) =>{console.log('eeeeeee',e); setSelectedOptions({ ...selectedOptions, material: e.target.value })}}
                    required
                    disabled={edit}
                  >
                    <MenuItem key={"All"} value={"All"}>
                        All
                    </MenuItem>
                    {state?.materials?.map((option: any) => (
                      <MenuItem key={option["material_num_short"]} value={option["material_num_short"]}>
                        {`${option["material_num_short"]} - ${option["description"]}`}
                      </MenuItem>
                    ))}
                  </Select>
                </Grid>
                <Grid item xs={6} md={6} xl={4}>
                  <InputLabel>Online Buffer</InputLabel>
                  <TextField
                    error={inputError?.onlineBuffer}
                    helperText={"Enter value from 0 to 99"}
                    placeholder="Enter Online Buffer"
                    type="number"
                    className={classes.modalInput}
                    value={selectedOptions?.onlineBuffer}
                    onChange={(e) => handleBufferOnChange(e.target.value, "online")}
                    required
                  ></TextField>
                </Grid>
                <Grid item xs={6} md={6} xl={4}>
                  <InputLabel>Offline Buffer</InputLabel>
                  <TextField
                    error={inputError?.offlineBuffer}
                    helperText={"Enter value from 0 to 99"}
                    placeholder="Enter Offline Buffer"
                    type="number"
                    className={classes.modalInput}
                    value={selectedOptions?.offlineBuffer}
                    onChange={(e) => handleBufferOnChange(e.target.value, "offline")}
                    required
                  ></TextField>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
          <div style={{ paddingRight: "5px", textAlign: "right" }}>
            <React.Fragment>
              <Tooltip title={"Save"}>
                <IconButton
                  onClick={handleModalSave}
                  color="primary"
                  disabled={
                    !selectedOptions?.deliveryPlant ||
                    !selectedOptions?.route ||
                    !selectedOptions?.material ||
                    !selectedOptions?.onlineBuffer ||
                    !selectedOptions?.offlineBuffer ||
                    inputError?.onlineBuffer ||
                    inputError?.offlineBuffer
                  }
                >
                  <SaveIcon />
                </IconButton>
              </Tooltip>
              <Tooltip title={"Cancel"}>
                <IconButton onClick={handleModalClose} color="primary">
                  <Clear />
                </IconButton>
              </Tooltip>
            </React.Fragment>
          </div>
        </Grid>
      </Grid>
    </div>
  );

  useEffect(() => {
    setBackdropLoader(true)
    getRouteBuffer(salesOrg.toString()).then((v: any) => {
      SetRows(v?.data);
    });
    getSalesOfficesAndRoutes(salesOrg.toString()).then((v: any) => {
   
      // const r_so: any[] = v.salesOffices;
      const r_so: any[] = v.plants;
      //console.log("r_so---->",r_so);
      const r_rt: any[] = v.routes;
      if (r_so && r_rt) {
        requestMissingContexts(["PLANTS"]).then((ctx) => {
          //console.log("ctx--->",ctx)
          const contexts: any = ctx;
          var deliveryPlants: Array<DeliveryPlant> = [];
          for (var i = 0; i < r_so.length; i++) {
            const so = r_so[i].plant;
            const desc = so + ": " + determineConfig(contexts, "PLANTS", so || "");
            const deliveryPlant: DeliveryPlant = { deliveryPlant: so, name: desc };
            deliveryPlants.push(deliveryPlant);
          }
          setBackdropLoader(false)
          setState({
            ...state,
            deliveryPlants,
            routes: r_rt
          });
        });
      }
    });
  }, []);

  useEffect(() => {
    if(selectedOptions?.deliveryPlant){
     // console.log('🚀 ~ file: AdminBufferConfig.tsx ~ line 450 ~ useEffect ~ selectedOptions', selectedOptions)
      GetMaterialList(salesOrg,selectedOptions?.deliveryPlant).then((v) => {
        if(v) setState({
          ...state,
          materials: v
        });
      })
    }
  }, [selectedOptions?.deliveryPlant])
  return (
    <div className={classes.root}>
      {doneLoading && enabled ? (
        <TableAbstraction
          settingsKey="ADM_BRC"
          options={{
            draggableColumns: {
              enabled: true
            },
            rowsPerPageOptions: [25, 50, 100],
            serverSide: false,
            selectableRows: "none",
            rowsPerPage: muiTable.rpp,
            onChangeRowsPerPage: (numberOfRows) => {
              muiTable.rpp = numberOfRows;
              setMuiTable(muiTable);
            },
            customToolbar: () => {
              return (
                <Tooltip title={`Add Delivery Plant`}>
                  <IconButton
                    onClick={() => {
                      handleModalClose();
                      setOpenEditWindow(true);
                    }}
                  >
                    <AddIcon />
                  </IconButton>
                </Tooltip>
              );
            }
          }}
          title="Route Buffer Configuration"
          columns={[
            {
              label: "Delivery Plant",
              name: "deliveryPlant",
              options: {
                searchable: true,
                filter: true
              }
            },
            {
              label: "Route",
              name: "route",
              options: {
                searchable: false,
                filter: false
              }
            },
            {
              label: "Material",
              name: "material",
              options: {
                searchable: false,
                filter: false
              }
            },
            {
              label: "Online Buffer",
              name: "onlineBuffer",
              options: {
                searchable: false,
                filter: false
              }
            },
            {
              label: "Offline Buffer",
              name: "offlineBuffer",
              options: {
                searchable: false,
                filter: false
              }
            },
            {
              label: " ",
              name: "remove",
              disableReorder: true,
              options: {
                filter: false,
                setCellProps: () => ({ align: "right" }),
                renderCell: (props) => {
                  const tableMeta = props.row;
                  if (useCompact)
                    return (
                      <React.Fragment>
                        <Tooltip title={"Edit"}>
                          <EditIcon
                            fontSize="small"
                            onClick={() => {
                              handleEdit(tableMeta);
                            }}
                          />
                        </Tooltip>
                        <Tooltip title={"Delete"}>
                          <DeleteIcon
                            fontSize="small"
                            onClick={() => {
                              setCurrent(tableMeta);
                              setConfirmDelete(true);
                            }}
                          />
                        </Tooltip>
                      </React.Fragment>
                    );
                  else
                    return (
                      <React.Fragment>
                        <Tooltip title={"Edit"}>
                          <IconButton
                            onClick={() => {
                              handleEdit(tableMeta);
                            }}
                          >
                            <EditIcon />
                          </IconButton>
                        </Tooltip>
                        <Tooltip title={"Delete"}>
                          <IconButton
                            onClick={() => {
                              setCurrent(tableMeta);
                              setConfirmDelete(true);
                            }}
                          >
                            <DeleteIcon />
                          </IconButton>
                        </Tooltip>
                      </React.Fragment>
                    );
                }
              }
            }
          ]}
          data={rows}
        />
      ) : enabled ? (
        <div className={classes.centerDiv}>
          <CircularProgress color="primary" />
        </div>
      ) : (
        <Alert severity="error">
          <AlertTitle>
            <LockIcon /> Access Error
          </AlertTitle>
          You do not currently have access to <strong>Vend Smart Admin</strong> activities for the{" "}
          <strong>{salesOrg}</strong> bottler.
        </Alert>
      )}

      <Modal open={openEditWindow} onClose={handleModalClose}>
        {modalBody}
      </Modal>

      <Dialog open={confirmDelete} onClose={() => setConfirmDelete(false)}>
        <DialogTitle>Confirm Deletion</DialogTitle>
        <DialogContent>
          <DialogContentText>Are you sure you wish to delete ?</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              handleDelete();
              setConfirmDelete(false);
            }}
            color="primary"
          >
            Yes
          </Button>
          <Button
            onClick={() => {
              // setEditedRow(undefined);
              setConfirmDelete(false);
            }}
            color="primary"
            autoFocus
          >
            No
          </Button>
        </DialogActions>
      </Dialog>
      {/* backdrop loader */}
      <Backdrop sx={{ color: "#fff", zIndex: (theme: any) => theme.zIndex.drawer + 1 }} open={backdropLoader}>
        <CircularProgress color="primary" />
      </Backdrop>
    </div>
  );
}
